import md5 from 'md5';
import localStorage from '@/common/utils/storage';

/**
 * 记录视频详情最新访问时间
 */
class CourseAccessReport {
  // 上报时间间隔
  reportDuration = 12 * 60 * 60 * 1000

  makeKey (userId) {
    return `course-access-report-${md5(userId)}`;
  }

  canReport (userId){
    if (!userId) {
      return false;
    }
    const storageKey = this.makeKey(userId);
    const value = Number(localStorage.get(storageKey)) || 0;
    const now = new Date().getTime();
    if (now - value > this.reportDuration) {
      localStorage.set(storageKey, now.toString());
      return true;
    }
    return false;
  }
}

export default new CourseAccessReport();
